// Расчёты ленты фото карточки (PhotoCarousel): какой кадр под мышью и какие кадры грузить. Чистые функции (покрыто тестами).

/** Кадр под мышью: ширина фото делится на n равных полос */
export function carouselZone(x: number, width: number, n: number): number {
  if (n <= 1 || !(width > 0)) return 0;
  return Math.max(0, Math.min(n - 1, Math.floor((x / width) * n)));
}

/** Кадры, у которых грузим картинку: текущий и соседние (листать дальше — без пустого кадра) */
export function visibleSlides(idx: number, n: number): Set<number> {
  const out = new Set<number>();
  for (const i of [idx - 1, idx, idx + 1]) if (i >= 0 && i < n) out.add(i);
  return out;
}
